export const FORTER_HEADER_NAME = 'Forter-Token-Cookie'
